module.exports = __webpack_public_path__ + "63e4ecb2457f930720c343a83df0c62d.svg";